import React from 'react';
import { Container, Body5 } from '@ui';
import { ResultContext, RUNNING_STATUS } from '@/contexts/ResultContext';
import { AnswerConfigContext } from '@/contexts/AnswerConfigContext';
import { AnswerFormatter } from '@classes/AnswerFormatter';
import { AnswerBody } from './AnswerBody';

const answerFormatter = new AnswerFormatter();

export const Answer = () => {
  const { enableMoreDetail, enableLinks, ignoreLatex } = React.useContext(AnswerConfigContext);
  const { runningStatus, answer, citationResult } = React.useContext(ResultContext);

  const displayAnswer = citationResult ? citationResult : answer;
  const formattedAnswer = answerFormatter.formatResult(displayAnswer, ignoreLatex);

  React.useEffect(() => {
    console.log('formattedAnswer', formattedAnswer);
  }, [formattedAnswer]);

  return (
    <Container>
      {runningStatus === RUNNING_STATUS.ERROR ||
        (runningStatus === RUNNING_STATUS.RETRYING_ERROR && (
          <Container top={24} bottom={24}>
            {runningStatus === RUNNING_STATUS.ERROR ? (
              <Body5 bold>Something went wrong. Answer may be incomplete. Try submitting again.</Body5>
            ) : (
              <Body5 bold>Something went wrong. Reconnecting...</Body5>
            )}
          </Container>
        ))}
      <AnswerBody
        answer={formattedAnswer}
        isStreaming={runningStatus === RUNNING_STATUS.RUNNING}
        enableLinks={enableLinks}
        enableMoreDetail={enableMoreDetail}
        ignoreLatex={ignoreLatex}
      />
    </Container>
  );
};
